module.exports = __webpack_public_path__ + "img/doctor.303c30e8.png";